import React from "react";

export default function IconArrow(svgProps) {
  return (
    <svg
      {...svgProps}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 5.75L7 9.25L10.5 5.75"
        stroke="white"
        strokeOpacity="0.6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
